var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.44.185 7.633 14.04 2.56 8.95a.628.628 0 0 0-.89 0L.183 10.438a.634.634 0 0 0 0 .894l7.004 7.027a.628.628 0 0 0 .89 0L23.816 2.57a.634.634 0 0 0 0-.894L22.33.185a.628.628 0 0 0-.89 0z","fill":"#484848"}));
}

Check.defaultProps = {"width":"24","height":"19"};

module.exports = Check;

Check.default = Check;
